package br.com.texeratx.boardgametimeapp.domain.usecases.expansions

import br.com.texeratx.boardgametimeapp.data.model.expansion.ExpansionDTO
import br.com.texeratx.boardgametimeapp.data.model.expansion.UpdateExpansionRequest
import br.com.texeratx.boardgametimeapp.data.repository.ExpansionRepository

class UpdateExpansionUseCase(
    private val repo: ExpansionRepository
) {
    suspend operator fun invoke(id: Long, body: UpdateExpansionRequest): Result<ExpansionDTO> =
        repo.updateExpansion(id, body)
}
